import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { guideActions } from '../ActionTypes';


export const fetchGuide = () => async (dispatch) => {
  try {
    dispatch({
      type: guideActions.GUIDE_FETCH_START
    });
    const resData = await Service.GET({
      name: 'guide',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: guideActions.GUIDE_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: guideActions.GUIDE_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};
export const saveGuide = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData,
      OrderNumber: Number(formData.OrderNumber)
    };
    dispatch({
      type: guideActions.GUIDE_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'guide',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: guideActions.GUIDE_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/guide'; }, 1000);
  } catch (error) {
    dispatch({
      type: guideActions.GUIDE_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};
export const resetForm = () => (dispatch) => dispatch({ type: guideActions.GUIDE_RESET_FORM });

export const editGuide = (guideId) => async (dispatch, getState) => {
  try {
    // dispatch(resetForm());
    const { guideList } = getState().guide;
    const data = guideList.find((item) => item.Id === guideId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: guideActions.GUIDE_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};


export const deleteGuide = (Id) => async (dispatch) => Service.DELETE({
  name: 'guide',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchGuide());
    return true;
  }
  throw new Error(res.message);
});
